import { request3 } from '../../utils/request'
// import { urlStringify } from '../../utils/index'

export default {
  // 商家数据汇总
  summary: option => {
    return request3('v1/stats/vendor/summary', option, true)
  },
  // 商家现金订单统计
  statscashorder: option => {
    return request3('v1/stats/vendor/statscashorder', option, true)
  },
  // 商家积分订单统计
  statspointsorder: option => {
    return request3('v1/stats/vendor/statspointsorder', option, true)
  },
  // 商家访问用户数统计
  statswxuserlogincount: option => {
    return request3('v1/stats/vendor/statswxuserlogincount', option, true)
  },
  // 会员统计
  statswxuserregcount: option => {
    return request3('v1/stats/vendor/statswxuserregcount', option, true)
  },
  // 商家用户访问入口统计
  statswxuserloginentry: option => {
    return request3('v1/stats/vendor/statswxuserloginentry', option, true)
  }
}
